// extracted by mini-css-extract-plugin
module.exports = {"container":"HeaderDesktop_container__2WcOi","logo":"HeaderDesktop_logo__2oDms","user":"HeaderDesktop_user__3sfg-","navlink":"HeaderDesktop_navlink__27Qt5"};